import { useState } from "react";
import axios from 'axios';
import { useNavigate,useLocation } from "react-router-dom";
import {url,urlLive} from '../../../constant';

//  @mui material full-page-loader
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function ResetPasswordWithCode() {
  const navigate = useNavigate();
  const location = useLocation();

  // Create a URLSearchParams object from the location's search string
  const queryParams = new URLSearchParams(location.search);
  // const email = queryParams.get('email');  // Access the 'email' parameter
  const token = queryParams.get('token');  // Access the 'email' parameter
  // console.log(email,token);
  const [code, setCode] = useState((token == null) ? '' : token);
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  // const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  // console.log("location:",location);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     setOpen(true);
  //     const response = await axios.post(`${url}auth/reset-password`, {
  //       email:email,
  //       token:code,
  //       password:newPassword,
  //       password_confirmation:passwordConfirmation
  //     });

  //     if (response.status === 200) {

  //       setMessage("Password has been reset successfully.");
  //       // Redirect to login page after successful password reset
  //       setTimeout(() => {
  //         setOpen(false);
  //         navigate("/authentication/sign-in")
  //       }, 2000);

  //     }
  //   } catch (error) {
      
  //     setOpen(false);
  //     console.log(error);

  //     setMessage("Failed to reset the password. Please check the reset code.");

  //     setTimeout(()=>{
  //       setMessage("");
  //     },1500);

  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission
  
    // Clear any previous messages
    setMessage("");
  
    // Input validation (basic)
    if (!newPassword) {
      alert("Nuova password obbligatorio.");
      return;
    }
  
    if (newPassword.length < 6) {
      alert("La password deve essere almeno di 6 caratteri.");
      return;
    }

    // Input validation (basic)
    if (!passwordConfirmation) {
      alert("Conferma nuova password obbligatorio.");
      return;
    }

    if (newPassword !== passwordConfirmation) {
      alert("Le password inserite non coincidono.");
      return;
    }
  
    
    try {
      setOpen(true); // Show loading indicator
  
      // Step 1: Get the email by token before resetting the password
      const email = await getEmailByToken(code); // Call getEmailByToken to fetch email
      // console.log(email);
      
      // Send reset password request
      const response = await axios.post(`${url}auth/reset-password`, {
        email: email,
        token: code,
        password: newPassword,
        password_confirmation: passwordConfirmation
      });
  
      // Handle successful response
      if (response.status === 200) {
        setMessage("Password modificata!");
        // Redirect to login page after successful password reset
        setTimeout(() => {
          setOpen(false); // Hide loading indicator
          navigate("/authentication/sign-in"); // Redirect to the sign-in page
        }, 2000);
      }

    } catch (error) {
      setOpen(false); // Hide loading indicator if an error occurs
      // console.error(error); // Log the error for debugging
  
      // Check if the error response exists, and handle it properly
      if (error.response && error.response.data) {
        setMessage(error.response.data.error || "Failed to reset the password. Please check the reset code.");
      } else {
        setMessage("An unexpected error occurred. Please try again.");
      }
  
      // Clear the message after a brief delay
      setTimeout(() => {
        setMessage("");
      }, 1500);
    }

  };
  

  // Fetch email by token from the backend
  const getEmailByToken = async (token) => {
    try {
      // Make the fetch request to the backend API
      const response = await fetch(`${url}auth/get-email-by-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Ensuring that we are sending JSON
        },
        body: JSON.stringify({ token }) // Send token in the body
      });

      // Check if the request was successful
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Something went wrong!');
      }

      // Parse the JSON response and return the email
      const data = await response.json();
      return data.email;

    } catch (error) {
      console.error('Error fetching email by token:', error);
      throw error; // Re-throw the error to handle it elsewhere if needed
    }
  };


  return (
    <BasicLayout coverHeight="50vh" bgImage={bgImage}>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
        }}

        open={open}
        transitionDuration={500}  // Smooth transition for the backdrop
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <MDBox
          variant="gradient"
          // bgColor="info"  
          bgColor="#183759"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={3}
          mb={2}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
          Inserisci la nuova password.
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            {/* <MDBox mb={2}>
              <MDInput
                type="text"
                label="Reset Code"
                variant="standard"
                fullWidth
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </MDBox> */}
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Nuova password"
                variant="standard"
                fullWidth
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mb={4}>
              <MDInput
                type="password"
                label="Conferma nuova password"
                variant="standard"
                fullWidth
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
              />
            </MDBox>
            {message && (
              <MDBox mb={2} mt={2} textAlign="center">
                <MDTypography variant="body1" color={message.includes("failed") ? "error" : "success"}>
                  {message}
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={6} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                // sx={{
                //   background: "#6281eb", // Initial background color
                //   "&:hover": {
                //     background: "#4a65d8", // Hover state color
                //   },
                // }}

                sx={{
                  background: '#183759', // 🔹 Your main color
                  "&:hover": {
                    background: '#204b80', // ✨ Slightly lighter for hover
                  },
                }}

                fullWidth
                type="submit"
              >
                Reset Password
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ResetPasswordWithCode;
